import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { PrepaidCardGiftBoxResponse } from '@models/prepaidCard';
import { useTranslation } from 'react-i18next';

interface Props {
    gift: PrepaidCardGiftBoxResponse;
}

function GiftCardSection({ gift }: Props) {
    const { t } = useTranslation('prepaidCard');

    return (
        <Container fullWidth spacing={4} align='center'>
            <ImageArea>
                <CardImage src={gift.imageUrl}
                    width={280}
                    height={176}
                    alt={gift.giftItemName ?? t('giftDetail.cardAlt')}
                    style={{ borderRadius: 12, objectFit: 'cover' }} />
            </ImageArea>
            <Text size='title-lg' fontWeight='bold' align='center'>
                {gift.giftItemName}
            </Text>
            {gift.status !== 'ISSUED' && gift.barcodeNo ? (
                <BarcodeArea fullWidth spacing={2} align='center'>
                    <CustomBarcode value={gift.barcodeNo} height={40} />
                    <Text size='body-long' align='center' fontWeight='regular'>
                        {formatBarcodeNo(gift.barcodeNo)}
                    </Text>
                </BarcodeArea>
            ) : null}
        </Container>
    );
}

function formatBarcodeNo(barcodeNo: string) {
    const digits = barcodeNo.replace(/\s/g, '');
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
}

const Container = styled(Column)`
    padding: 16px;
    border-radius: 8px;
    background-color: var(--color-white);
    border: 1px solid var(--color-gray2);
`;

const ImageArea = styled.div`
    align-items: center;
    aspect-ratio: 1 / 1;
    display: flex;
    justify-content: center;
    min-width: 200px;
`;

const CardImage = styled(Image)`
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const BarcodeArea = styled(Column)`
    padding-top: 8px;
`;

export default GiftCardSection;
